import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SchedulePage } from "@/features/schedule/SchedulePage";

const search = z.object({
  weeks: z.enum(["4", "8", "12"]).optional(),
  skill: z.string().optional(),
  view: z.enum(["plan", "estimates"]).optional(),
});

export const Route = createFileRoute("/_app/schedule/")({
  validateSearch: search,
  component: () => <SchedulePage search={Route.useSearch()} />,
});
